var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pdfCom"},_vm._l((_vm.pdfHTML),function(item){return _c('canvas',{key:item,attrs:{"id":'canvas' + item}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }